import UserInfoActions from '../../../../actions/UserInfoActions';
import SessionActions from '../../../../actions/SessionActions';
import config from '../../../../config';

export const actions = {
    changePassword(state, success, error) {
        UserInfoActions.changePassword({
            current_password: state.curPassword,
            new_password: state.newPassword,
            new_password_confirmation: state.confirmationPassword,
            client_id: config.clientId
        }).then(data => {
            if (data.error && data.error.invalid_parameters) {
                error && error(data.error.invalid_parameters);
            } else if (data) {
                SessionActions.saveAccessData(data);

                success && success();
            }
        });
    }
};
